import { FunctionComponent } from 'react';

export interface BadgeProps {
  label: string;
  bgColor?: string;
  textColor?: string;
}

export const Badge: FunctionComponent<BadgeProps> = ({
  label,
  bgColor = '#E4EAF2',
  textColor = '#181B23',
}) => {
  return (
    <span
      className="pb-0.2 text-body inline-flex items-center rounded border px-1.5 font-semibold"
      style={{ backgroundColor: bgColor, color: textColor }}
    >
      {label}
    </span>
  );
};
